<template>
  <div class="singlePage" :class="[`singlePage--${content.key}`]">
    <div class="singlePage__inner">
      <div v-if="!content.contentJson?.hideBreacrumbsTitleInput" class="container">
        <breadcrumbs
          :list="[
            {
              url: '/',
              title: 'Ofix',
            },
            {
              url: '/',
              title: content.title,
            },
          ]"
          class="textPage__breadcrumbs"
        />
        <page-title
          v-if="content?.contentJson?.blocks[0].type !== 'LandingHeaderSection'"
          :title="content.title"
        />
      </div>
      <template v-if="content.contentJson">
        <template v-if="content.contentJson.pageType === 'sideMenu'">
          <div class="singlePage__wrapper container">
            <SidebarMenu
              title="Zobacz również"
              :links="links"
              variant="page"
              class="singlePage__menu"
            />
            <PageSections :sections="content.contentJson.blocks" class="singlePage__sections" />
          </div>
        </template>

        <PageSections v-else :sections="content.contentJson.blocks" disable-bottom-padding />
      </template>
      <template v-if="content.content">
        <div
          v-if="isIframe"
          class="singlePage__content container"
          ref="iframeWrapper"
          v-html="iframe"
        />
        <div v-else class="singlePage__content container">
          <CmsWysiwyg :html="content.content" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import CmsWysiwyg from '../components/Cms/CmsWysiwyg';
import Breadcrumbs from '../components/Breadcrumbs';
import PageTitle from '../components/PageTitle';
import PageSections from '@/components/Editor/Page/PageSections';
import SidebarMenu from '@/components/SidebarMenu';

export default {
  name: 'SinglePage',
  components: { SidebarMenu, PageSections, PageTitle, Breadcrumbs, CmsWysiwyg },
  async asyncData({ $config, error, $axios, route }) {
    try {
      const { data } = await $axios.get(
        `${$config.baseOfixApi}/e-commerce/v1/contents/${route.params.slug}`,
        {
          useCache: true,
        },
      );

      return { content: data.content, seo: data.seo };
    } catch {
      error({ statusCode: 404, message: 'Page not found' });
    }
  },
  data() {
    return {
      iframe: null,
      script: null,
    };
  },
  computed: {
    isIframe() {
      return this.content.content.includes('<iframe');
    },
    links() {
      return this.content.similarContent.map(({ title, key }) => ({
        name: title,
        url: `/${key.replace(/-new$/, '')}`,
      }));
    },
  },
  mounted() {
    if (this.$nuxt.$loading._isVue) {
      if (this.$nuxt.$loading.finishCreate()) {
        this.$nuxt.$loading.finishCreate();
      }
    }

    if (this.content.content && this.content.content.includes('<iframe')) {
      let html = this.content.content;

      if (html.startsWith('<p>')) {
        html = html.slice(3);
      }

      if (html.endsWith('</p>')) {
        html = html.slice(0, html.length - 4);
      }

      this.iframe = html.substring(html.indexOf('<iframe'), html.indexOf('</' + 'iframe>') + 9);

      if (html.includes('<script>')) {
        this.script = html.substring(html.indexOf('<script>') + 8, html.indexOf('</' + 'script>'));
      }
    }

    if (this.$refs.iframeWrapper) {
      const script = document.createElement('script');
      script.innerHTML = this.script;
      this.$nextTick(() => {
        this.$refs.iframeWrapper.appendChild(script);
      });
    }
  },
  head() {
    return {
      title: this.$helper.metaTitle(this?.seo?.title ? this.seo.title : this.content.title),
      meta: this.$helper.metaDescription(
        this?.seo?.metaTags ? this.seo.metaTags : this.content.metaTags,
      ),
    };
  },
};
</script>

<style lang="scss">
.singlePage {
  $root: &;

  &__content {
    display: flex;
    background-color: $cWhite;
    padding: 6.5rem 3rem;

    @include rwd('large-tablet') {
      flex-direction: column;
      padding: 1rem 3rem;
    }

    @include rwd('tablet') {
      width: calc(100% + 60px);
      margin-left: -30px;
    }
  }

  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    padding-bottom: 5rem;

    @include rwd('large-tablet') {
      flex-direction: column-reverse;
    }
  }

  &__menu {
    position: sticky;
    top: 100px;
    flex: 0 0 300px;
    max-width: 300px;

    @include rwd('laptop') {
      flex: 0 0 250px;
      max-width: 250px;
    }

    @include rwd('large-tablet') {
      position: static;
      margin-top: 3rem;
      top: unset;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__sections {
    padding-left: 5.2rem;
    flex: 1;
    max-width: 100%;

    @include rwd('large-tablet') {
      padding-left: 0;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &--kontakt-new {
    background-color: $cWhite;
    border-top: 1px solid $cAddLight;
  }
}
</style>
